import axios from "axios";
import { CALENDAR_URL } from "../config/apiConstants";
import { prepareRequestparams } from "../helpers/requestHelpders";

export async function getCalendar(sort, filter, page, include) {
  return await axios.get(
    CALENDAR_URL,
    prepareRequestparams(sort, filter, page, include)
  );
}
